module.exports = __webpack_public_path__ + "img/vipUserIcon.da8bd34f.png";